/*
 * Throttle function borrowed from:
 * Underscore.js 1.5.2
 * http://underscorejs.org
 * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Underscore may be freely distributed under the MIT license.
 */

// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
function throttle(func, wait) {
	var context, args, result;
	var timeout = null;
	var previous = 0;
	var later = function() {
		previous = new Date;
		timeout = null;
		result = func.apply(context, args);
	};
	return function() {
		var now = new Date;
		if (!previous) previous = now;
		var remaining = wait - (now - previous);
		context = this;
		args = arguments;
		if (remaining <= 0) {
			clearTimeout(timeout);
			timeout = null;
			previous = now;
			result = func.apply(context, args);
		} else if (!timeout) {
			timeout = setTimeout(later, remaining);
		}
		return result;
	};
}

/*
 * Returns distance between element and window top
 * @method getOffsetTop
 * @param {Node} element
 */
/*function getOffsetTop(element) {
		var top = element.offsetTop,
				offsetParent = element.offsetParent;

		// escalate offset parent assignation
		while (offsetParent) {
				top += offsetParent.offsetTop;
				offsetParent = offsetParent.offsetParent;
		}

		return top;
}*/

/*
 * Returns a random number
 */
/*function randomNumber(min, max) {
	return Math.floor(Math.random() * (max - min)) + min;
}*/


/*
 * Returns the scroll top of the page
 */
function getScrollPage(){
	return document.body.scrollTop || document.documentElement.scrollTop;
}

/*
 * Returns a boolean to know if we past the header
 */
function pastHeader(){
	// Send the boolean
	return getScrollPage() > document.getElementsByTagName('header')[0].offsetHeight + 100; // add 100px of margin
}
